/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/speaker_dominion': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<circle pid="0" cx="21.5" cy="21.5" r="2"/><path pid="1" d="M14 19.5c3.032 0 5.5-2.467 5.5-5.5S17.032 8.5 14 8.5 8.5 10.967 8.5 14s2.468 5.5 5.5 5.5zm0-10c2.481 0 4.5 2.019 4.5 4.5s-2.019 4.5-4.5 4.5-4.5-2.019-4.5-4.5 2.019-4.5 4.5-4.5z"/><path pid="2" d="M28 19.354L31.354 16 28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646zM30.646 16L28 18.646v-5.293L30.646 16zM16 1.354L18.646 4h-5.293L16 1.354zM1.354 16L4 13.354v5.292L1.354 16zM16 30.646L13.354 28h5.292L16 30.646zM26 26H6V6h20v20z"/>'
  }
})
